import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Main from 'layouts/Main';
import Container from 'components/Container';
import {Day1, Idiom, Soliloquium, Panchtantar, MonoActing, MathVerde, MathAdventure, Design, ScienceSongSpoof, Mun, CodeQuest, Scratch, Flamboyance, EpochsOfIndia, Stroke} from 'views/Goonj2024/components';
import { Day2Goonj2024 } from './components';


const FaqGroupItem = ({ tittle, items }) => {
  const theme = useTheme();
  return (
    <Main>
      <Box>
        <br></br>
        <Typography  variant='h4' align='center' fontWeight={800}>
          GOONJ 2024
        </Typography>
        <br></br>
        <br></br>

        <Typography variant='h6' align='center' fontWeight={700}>
          INTRODUCTION
        </Typography>

        <Box id='Day1' marginBottom={2} marginLeft={3} marginRight={3}>
          <br></br>
          <Typography
            variant={'subtitle1'}
            align='justify'

          >
            The Inter-School Fest GOONJ 2024 was hosted by National Public School, Yeshwanthpur on Friday, 19 July and Saturday, 20 July 2024. It featured an array of events tailored to challenge and inspire participants across different domains. From linguistic finesse in events like Idiom Maestro and Soliloquium, to creative storytelling with a twist in Panchatantra Tales with Twist, students demonstrated their prowess not only in communication and imagination, but also in Creative Advertisements. The Stroke of Genius commenced with an explosion of colour and energy as the participants showcased their talents and creativity. The fusion Purva Paschima featured mesmerising choreography.
            <br></br>
            <br></br>
            The competition also delved into the realms of performing arts with Mono Acting, where participants brought characters to life with compelling performances. Meanwhile, in Math Arch, Math Verde and Math Adventureville, mathematical ingenuity took centre stage. In an era where creativity meets technology, Goonj featured events such as Code Quest, Scratch-O-Anime and Code Crafters, where young minds showcased their programming skills through animation and coding challenges. Designer Dreamscape brought out the artistic flair of participants through creative design challenges, blending aesthetics with functionality.
            <br></br>
            <br></br>
            Deeper intellectual engagement was fostered through events like Model United Nations, Lex Magna-Moot Court, Debattle and Vaad-Vivaad, where students debated, negotiated and presented their perspectives on global issues, historical debates and philosophical questions. The Throne of Apollo witnessed performances from soulful classical renditions to energetic contemporary beats. Science found its creative expression in events like Science Song Spoof and Navigating the Storm, where scientific concepts were communicated through music and practical challenges. Epochs of India offered a glimpse into the rich cultural heritage of India, while Manifesto provided a platform for students to showcase the fashion and style statement for a better future. Geonomy, Caveat Emptor, Flamboyance, Explicadum and Eximii Magistri gave opportunity to learn and manage crisis and develop entrepreneurial skills based on principles of economics.
            <br></br>
            <br></br>
            The Inter-School Cultural Fest concluded on a positive note with a vibrant closing ceremony, leaving everyone looking forward to the next edition. Presidency School, Nandini Layout bagged the Rolling Trophy. Goonj 2024 was not just a competition but a celebration of creativity, intellect and innovation. The Inter-School Cultural Fest concluded on a positive note with a vibrant closing ceremony. Presidency School, Nandini Layout bagged the Rolling Trophy of the Inter School Fest Goonj. ‘Goonj was not just a competition but a celebration of Collaboration, Creativity and Intellect’ says Principal Sheeja Manoj.
          </Typography>
          <br></br>
          <Typography variant='h6' align='center' id='Day1' fontWeight={700}>
            DAY 1
          </Typography>
          <Day1 />
        </Box>

        <Box>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >Idiom Maestro </Typography>
              <Typography align='right'> - Charade Challenge: Idiom Edition!</Typography>

            </Box>
            <AccordionDetails>
            invited participants to interpret idioms through the dynamic medium of Dumb Charades. 

            </AccordionDetails>

            <Idiom/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day1" sx={{ ml: 'auto' }}> Back to DAY 1</a>
            </Box>

          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >Soliloquium </Typography>
              <Typography align='right' > - Shakespeare's Spotlight: Soliloquy Showdown</Typography>

            </Box>
            <AccordionDetails>
            where participants performed evocative soliloquies from Shakespearean plays, demonstrating their dramatic prowess.
            </AccordionDetails>

            <Soliloquium />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >Panchatantra Tales with a Twist </Typography>
              <Typography align='right' >- Reimagined Panchatantra: Creative Climaxes</Typography>

            </Box>
            <AccordionDetails>
            This imaginative event encouraged participants to creatively alter the climaxes of classic Panchatantra stories, showcasing their storytelling skills.
            </AccordionDetails>

            <Panchtantar />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >Mono Acting </Typography>
              <Typography align='right' >- Mythic Monologues Magic</Typography>

            </Box>
            <AccordionDetails>
            This event required participants to enact monologues of mythological characters, showcasing their dramatic skills and understanding of cultural heritage.
            </AccordionDetails>

            <MonoActing />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >Math Verde </Typography>
              <Typography align='right' >-Forest of Fractions</Typography>

            </Box>
            <AccordionDetails>
            The participants created forest landscapes using circles and their fractional parts, blending artistic creativity with mathematical concepts.
            </AccordionDetails>

            <MathVerde />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >Math Adventureville </Typography>
              <Typography align='right' >- Math Explorers: Adventure Awaits!</Typography>

            </Box>
            <AccordionDetails>
            This event challenged participants to design a board game incorporating mathematical principles, presenting math in a fun and interactive manner.
            </AccordionDetails>

            <MathAdventure />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >Designer Dreamscape </Typography>
              <Typography align='right' >- Animal Kingdom Science Showcase</Typography>

            </Box>
            <AccordionDetails>
            Participants donned animal costumes and presented scientific concepts related to their chosen animal using creative props.
            </AccordionDetails>

            <Design />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000}>Science Song Spoof</Typography>
              <Typography align='right' >- Scientific Song Parody Battle</Typography>


            </Box>
            <AccordionDetails>
            Participants crafted humorous parodies of popular songs with lyrics based on scientific concepts.
            </AccordionDetails>

            <ScienceSongSpoof />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>
          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000}>NPSYPR MUN </Typography>
              <Typography align='right' >- Where Tomorrow's Leaders Debate Today</Typography>


            </Box>
            <AccordionDetails>
            (Model United Nations) provided students with a platform to represent countries, debate, and present strong arguments on selected topics.
            </AccordionDetails>

            <Mun />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000} align='left' >Code Quest Junior</Typography>
    <Typography align='right' > - Interactive Story Coders</Typography>

  </Box>
  <AccordionDetails>
   Students created interactive stories using graphical block-based coding platform Pictoblox, incorporating characters, backgrounds, and dialogues.
  </AccordionDetails>

  <CodeQuest />
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
  </Box>
</Box>

<br></br>

<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000} align='left' >Scratch O Anime</Typography>
    <Typography align='right' >- Animated Messages for Change</Typography>

  </Box>
  <AccordionDetails>
  Participants developed animations conveying messages for Anti-Child Labour Day 2024.
  </AccordionDetails>

  <Scratch />
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
  </Box>
</Box>

<br></br>

<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000} align='left' >Flamboyance </Typography>
    <Typography align='right' >- Marketing Mastery: Product Pitch</Typography>

  </Box>
  <AccordionDetails>
  Students competed to market and sell products using effective advertising strategies.
  </AccordionDetails>

  <Flamboyance />
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
  </Box>
</Box>

<br></br>

<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000} align='left' >Epochs of India </Typography>
    <Typography align='right' >-Historic India: Monumental Messages</Typography>

  </Box>
  <AccordionDetails>
  Students enacted scenes from Indian history with a monument backdrop to convey social messages.
  </AccordionDetails>

  <EpochsOfIndia />
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
  </Box>
</Box>

<br></br>

<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000} align='left' >Stroke of Genius Emotion in Colours </Typography>
    {/* <Typography align='right' >- Math Explorers: Adventure Awaits!</Typography> */}

  </Box>
  <AccordionDetails>
  Painting Contest a Painting Competition where participants expressed emotions through vivid textures, colours and strokes.
  </AccordionDetails>

  <Stroke />
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
  </Box>
</Box>





          <Day2Goonj2024/>

        </Box>
      </Box>
    </Main>
  );
};

FaqGroupItem.propTypes = {
  tittle: PropTypes.string,
  items: PropTypes.array.isRequired,
};

const Goonj2024 = () => {
  return (
    <Box>
      <Box marginBottom={1}>
        <FaqGroupItem
          items={[
            
          ]}
        />
      </Box>
    </Box>
  );
};

export default Goonj2024;